import React, { useState, useCallback, useContext } from 'react';
import useStyles from './Login.styles';
import { Box, TextField, Typography, Button, SvgIcon } from '@material-ui/core';
import RedbullIcon from '../../assets/images/redbullIcon/RedbullIcon';
import { endpoints } from '../../utils/endpoints';
import { useHistory } from 'react-router-dom';
import { EPaths } from '../../types/enums/EPaths';
import { SessionContext } from '../../contexts/session/SessionContext';
import useApi from '../../utils/useApi';
import { useTranslation } from 'react-i18next';
import tPaths from '../../utils/tPaths';
import RedbullLogoIcon from '../../assets/images/redbullIcon/RedBullLogoIcon';
import useSnackbar from '../../utils/useSnackbar';

const Login = () => {
  const styles = useStyles();
  const pushSnack = useSnackbar();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();
  const { updateToken } = useContext(SessionContext);
  const { post } = useApi(null);

  const { t } = useTranslation();

  const handleClickLogin = useCallback(() => {
    if (password.length < 8 || password.length > 32) {
      pushSnack({ message: t(tPaths.login.passwordLengthError), severity: 'error' });
      return;
    }
    post({
      endpoint: endpoints.login,
      body: { email, password },
      onSuccess: (response) => {
        updateToken(response?.data.accessToken);
        history.replace(EPaths.Dashboard);
      },
    });
  }, [email, history, password, post, pushSnack, t, updateToken]);

  const handleEmailChange = useCallback(
    ({ target: { value } }: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      setEmail(value),
    [],
  );
  const handlePasswordChange = useCallback(
    ({ target: { value } }: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
      setPassword(value),
    [],
  );

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter') {
        handleClickLogin();
      }
    },
    [handleClickLogin],
  );

  return (
    <Box className={styles.background}>
      <Box className={styles.loginForm}>
        {/* <SvgIcon component={RedbullIcon} /> */}
        <Box py={1}>
          <RedbullLogoIcon />
        </Box>
        <Box className={styles.inputContainer}>
          <Typography variant="subtitle2" className={styles.inputLabel}>
            {t(tPaths.login.email)}
          </Typography>
          <TextField
            onChange={handleEmailChange}
            InputProps={{
              classes: {
                input: styles.inputs,
              },
            }}
            onKeyDown={handleKeyDown}
          />
          <Typography variant="subtitle2" className={styles.inputLabel}>
            {t(tPaths.login.password)}
          </Typography>
          <TextField
            onChange={handlePasswordChange}
            type="password"
            InputProps={{
              classes: {
                input: styles.inputs,
              },
            }}
            onKeyDown={handleKeyDown}
          />
        </Box>
        <Button color="secondary" onClick={handleClickLogin}>
          {t(tPaths.login.logIn)}
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
